import { createAction } from '@reduxjs/toolkit';
import {FrameDto} from "@hec/api-dtos";

interface GetSelectableSectionFragmentsSucceededActionProps {
  sectionFragmentsDto: FrameDto[];
}

export const getSelectableSectionFragmentsAction = createAction('getSelectableSectionFragmentsAction');
export const getSelectableSectionFragmentsSucceededAction = createAction<GetSelectableSectionFragmentsSucceededActionProps>('getSelectableSectionFragmentsSucceededAction');
